import { Injectable } from '@angular/core';
import {SettingsProvider} from '../settings/settings';
import {AnalyticsProvider} from '../analytics/analytics';
import {AlertController} from 'ionic-angular';


const initialUsagesUntilAsking = 5;
const laterUsagesUntilAsking = 2;

/*
  Generated class for the NameSurveyProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NameSurveyProvider {

  constructor(private settings: SettingsProvider, private analytics: AnalyticsProvider, private alertCtrl: AlertController) {
  }

  eventuallyShowSurvey() {
    const surveyAlreadyAnswered = this.settings.getLocalBool('nameSurvey.alreadyAnswered');
    const surveyRejected = this.settings.getLocalBool('nameSurvey.rejected');
    const remainingUsagesUntilAsking = this.settings.getLocalNumber('nameSurvey.remainingUsagesUntilAsking');
    const readyToAsk = remainingUsagesUntilAsking === 0;
    const firstTimeUse = remainingUsagesUntilAsking === null; // key not saved means first time use after NameSurvey has been added

    if (surveyAlreadyAnswered === true || surveyRejected === true)
      return;

    if (readyToAsk) {
      this.ask();
    }
    else if (firstTimeUse) {
      this.askLater(initialUsagesUntilAsking);
    }
    else {
      this.reduceRemainingUsagesUntilAsking();
    }
  }

  private askLater(remainingUsages: number) {
    this.settings.setLocalNumber('nameSurvey.remainingUsagesUntilAsking', remainingUsages);
  }

  private dontBotherMe() {
    this.settings.setLocalBool('nameSurvey.rejected', true);
  }

  private reduceRemainingUsagesUntilAsking() {
    const remainingUsagesUntilAsking = this.settings.getLocalNumber('nameSurvey.remainingUsagesUntilAsking');
    this.settings.setLocalNumber('nameSurvey.remainingUsagesUntilAsking', remainingUsagesUntilAsking - 1);
  }

  private storeResult(preferredName: string) {
    this.analytics.emitEvent('nameSurvey', 'answer', preferredName);
    this.settings.setLocalBool('nameSurvey.alreadyAnswered', true);
  }

  private ask() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Namensumfrage');
    alert.setMessage('Ihre Meinung ist gefragt: Welcher Name passt besser zu dieser App? Vielen Dank!');

    alert.addInput({
      type: 'radio',
      label: 'Arznei+Haut',
      value: 'Arznei+Haut'
    });

    alert.addInput({
      type: 'radio',
      label: 'Trigger Scout DERMA',
      value: 'Trigger Scout DERMA'
    });

    alert.addInput({
      type: 'radio',
      label: 'Causeek DERMA',
      value: 'Causeek DERMA'
    });

    alert.addButton({
      text: 'Auswahl bestätigen',
      role: null,
      handler: data => {
        if (!data)
          return false;

        this.storeResult(data);
      }
    });
    alert.addButton({text: 'Später fragen', role: null, handler: () => this.askLater(laterUsagesUntilAsking)});
    alert.addButton({text: 'Nicht wieder fragen', cssClass: 'standard-last-alert-button', role: null, handler: () => this.dontBotherMe()});

    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/name-survey/name-survey.ts